import React, { useState, useEffect } from 'react';
import AutoComplete from "components/autoComplete";
import Tuss from "assets/json/tuss.json";
import axios from "axios";

import { Grid, Switch, Button, FormControlLabel } from '@material-ui/core';
import useApi from 'hooks/useApi';

function NovoProcedimento({save, listSave, disabled, opened = false}){
    const api = useApi();
    const [procedimento, setProcedimento] = useState({id: null, qtd: null});
    const [agrupamentos, setAgrupamentos] = useState([]);
    const [agrupamento, setAgrupamento] = useState(null);
    const [tipoLista, setTipoLista] = useState(false);
    const [novo, setNovo] = useState(false);

    useEffect(()=> {
        if(opened) setNovo(true);
        if(!opened) loadAgrupamentos();
    }, []);

    useEffect(()=> {
        if(procedimento.id && !procedimento.qtd) setProcedimento({...procedimento, qtd: 1});
    }, [procedimento]);

    async function loadAgrupamentos(){
        
        try {
            const request = await api.get("/agrupamentos/lista/procedimento");
            const response = request.data.payload;
            setAgrupamentos(response);
        } catch (error) {
            console.log(error);
        }
       
    }

    function openAgrupamentoDeProcedimentos(single){
        setAgrupamento(single);
    }

    function clearAll(){
        setProcedimento({id: '', qtd: ''});
        setTipoLista(false);
        setAgrupamento(null);
        if(!opened) setNovo(false);
    }

    function adicionar(){

        if(!procedimento.id) {
            procedimento.qtd = Number(procedimento.qtd);
            procedimento.id = Number(procedimento.id);
        }

        if(agrupamento){
            listSave(agrupamento.lista);
        }else{
            save(procedimento);
        }

        clearAll();

    }

    return(
        <div className="procedimentos novo">
            {
                !novo && (
                    <div className="close">
                        <Grid className="page-actions" container justify="flex-start" alignItems="center">
                            <Button disabled={disabled} variant="contained" onClick={() => setNovo(true)} color="primary">Adicionar</Button>
                        </Grid>
                    </div>
                )
            }
           
            {
                novo && (
                    <div className="open">
                        {
                            !opened && (
                                <Grid container spacing={2}>
                                    <Grid item md={3} xs={12}>
                                        <FormControlLabel
                                            control={<Switch onChange={() => setTipoLista(!tipoLista)} color="primary" name="checkedA" />}
                                            label="Grupo de Procedimentos"
                                        />
                                    </Grid>
                                </Grid>
                            )
                        }
                       
                        <Grid container spacing={2}>
                            {
                                !tipoLista ? (
                                    <>
                                        <Grid item md={3} xs={12}>
                                            <AutoComplete 
                                                list={Tuss} 
                                                onChangeHandle={setProcedimento} 
                                                label={"Código"}
                                                object={'id'} 
                                                value={procedimento} 
                                            />
                                        </Grid>
                                        <Grid item md xs={12}>
                                            <AutoComplete 
                                                list={Tuss} 
                                                onChangeHandle={setProcedimento} 
                                                label={ "Procedimento" }
                                                object={'desc'} 
                                                value={procedimento} 
                                            />
                                        </Grid>
                                        <Grid item md={2} xs={12}>
                                            <div className="input-wrapper">
                                                <label htmlFor="input-2124">qtd</label>
                                                <input type="number" value={procedimento.qtd || ""} onChange={(evt) => setProcedimento({...procedimento, qtd: evt.target.value})} id="input-2124" />
                                            </div>
                                        </Grid>
                                    </>
                                ) : (
                                    <Grid item md xs={12}>
                                        <AutoComplete 
                                            list={agrupamentos} 
                                            onChangeHandle={openAgrupamentoDeProcedimentos} 
                                            label={"Lista de Procedimentos"}
                                            object={'titulo'} 
                                            value={''} 
                                        />
                                    </Grid>
                                )
                            }
                           
                        </Grid>
                        <Grid className="page-actions" container justify="flex-start" alignItems="center">
                            <Button disabled={!procedimento.id && !agrupamento} variant="contained" onClick={adicionar} color="primary">{tipoLista ? 'Adicionar Lista' : "Incluir"}</Button>
                            <Button variant="contained" onClick={() => clearAll()}>Cancelar</Button>
                        </Grid>
                    </div>
                )
            }
            
        </div>
    )
}

export default NovoProcedimento;